import { UUID } from 'src/types/utility';
import { MODAL_MODES } from 'src/utils/constants';
export type CustomerType = Omit<CreateCustomerPayload, 'id'> & { id: UUID };

export enum CUSTOMER_FEATURE_SETTINGS {
  SLEEP_WAKE = 'SLEEP_WAKE',
  SLEEP_REM = 'REM',
  SLEEP_APNEA = 'APNEA',
}

export type CreateCustomerAccessPayload = {
  customerId: UUID;
  ipAddresses: string[];
  throughput: string;
  enabled: boolean;
};

export type CustomerAccessFormData = Omit<
  CreateCustomerAccessPayload,
  'ipAddresses'
> & {
  ipAddresses: string;
};

export type CustomerFeatureSettings = {
  customerId: UUID;
  [CUSTOMER_FEATURE_SETTINGS.SLEEP_WAKE]?: boolean;
  [CUSTOMER_FEATURE_SETTINGS.SLEEP_REM]?: boolean;
  [CUSTOMER_FEATURE_SETTINGS.SLEEP_APNEA]?: boolean;
};

export type CustomerFeatureSettingsFormData = {
  sleepWakeRemEnabled: boolean;
  sleepApneaEnabled: boolean;
};

export type CustomerFeatureSettingResponse = {
  name: CUSTOMER_FEATURE_SETTINGS;
  featureAvailable: boolean;
  customerId: string;
  [key: string]: unknown;
};

export type HPFeatureSettingResponse = {
  feature: CUSTOMER_FEATURE_SETTINGS;
  available: boolean;
}[];

export type CustomersSdkActivityResponse = {
  customerId: UUID;
  throughput: 'HIGH' | 'LOW';
  apiCallsLast24Hours: number;
  apiCallsLastMinute: number;
  apiAccessEnabled: boolean;
  activeLast24Hours: boolean;
};

export type CreateCustomerPayload = {
  id?: string;
  name: string;
  address: string;
  contactName: string;
  contactEmail: string;
  regionalAccess: string[];
};

// EMR Facilities
export type FacilityType = {
  id: UUID;
  lineOfBusiness: {
    shortDesc: string;
    longDesc: string;
  };
  country: string;
  city: string;
  postalCode: string;
  timeZoneOffset: number;
  facId: number;
  countryId: number;
  headOffice: true;
  orgUuid: UUID;
  emailAddress: string;
  addressLine1: string;
  addressLine2: string;
  facilityName: string;
  state: string;
  fax: string;
  bedCount: number;
  facilityCode: string;
  orgName: string;
  active: true;
  timeZone: string;
  healthType: string;
  facilityStatus: string;
  environment: string;
  phone: string;
  orgDbType: string;
  billingStyleCountry: string;
};

export type CustomerTenantType = {
  id: string;
  name: string;
  emrId?: string | null; //id of the facility id that it's synced too
};

export type CustomerTypeWithAccessAndFeatureSettingsData =
  CreateCustomerPayload &
    CustomerAccessFormData &
    CustomerFeatureSettingsFormData;

export type CustomerModalType = {
  mode: keyof typeof MODAL_MODES | '';
  visible: boolean;
};

export type SiteFeatureSettingResponse = {
  featureName: CUSTOMER_FEATURE_SETTINGS;
  endHour: number;
  startHour: number;
};
export type MotionAggregatedDataResponse = {
  motionDailyResponse: {
    time: string;
    postureCount: number;
    inBedDataPointsCount: number;
    highMotionCount: number;
    mediumMotionCount: number;
    lowMotionCount: number;
  }[];
};
